/* eslint-disable */
import { auth } from "@/plugins/auth/firebase.js";
import * as firebase from "firebase";
import Cookie from "js-cookie";
import Vue from "vue";
import { _ } from "vue-underscore";
import axios from "axios";
import * as vars from "@/vars.json";
import functions from "../../../../../facturapp/functions/functions";

export const summary = {
  namespaced: true,
  state: {
    criteria: "",
    transactions: null,
    purchasesDayList: { results: [] },
    purchasesWeekList: { results: [] },
    purchasesMonthList: { results: [] },
    purchasesYearList: { results: [] },
    salesDayList: null,
    salesWeekList: null,
    salesMonthList: null,
    salesYearList: null,
    currentItem: { results: [] },

    allDaySales: [],
    currentType: "sales",

    isLoading: false,
    currentShop: {},

    salesList: null,
    purchasesList: null,
    expensesList: null,
    returnsList: null,
    tranfersList: null,    ordersList: null,
    revenue: null,
    registrations: [],

    // Category analytics
    categorySalesDailyList: null,
    categorySalesMonthlyList: null,
    categoryAnalytics: {
      daily: {},
      monthly: {}
    }
  },
  mutations: {
    SET_ALL_DAY_SALES(state, payload) {
      state.allDaySales = payload;
    },
    SET_TODAY_PURCHASES_LIST(state, payload) {
      state.purchasesDayList = payload;
    },
    SET_WEEK_PURCHASES_LIST(state, payload) {
      state.purchasesWeekList = payload;
    },
    SET_MONTH_PURCHASES_LIST(state, payload) {
      state.purchasesMonthList = payload;
    },
    SET_YEAR_PURCHASES_LIST(state, payload) {
      state.purchasesYearList = payload;
    },
    SET_TODAY_SALES_LIST(state, payload) {
      state.salesDayList = payload;
    },
    SET_WEEK_SALES_LIST(state, payload) {
      state.salesWeekList = payload;
    },
    SET_MONTH_SALES_LIST(state, payload) {
      state.salesMonthList = payload;
    },
    SET_YEAR_SALES_LIST(state, payload) {
      state.salesYearList = payload;
    },
    SET_CURRENT_SHOP(state, payload) {
      state.currentShop = payload;
    },

    SET_LOADING(state, payload) {
      state.isLoading = payload;
    },
    //NEW MODS
    SET_SALES_LIST(state, payload) {
      state.salesList = payload;
    },
    SET_PURCHASES_LIST(state, payload) {
      state.purchasesList = payload;
    },
    SET_EXPENSES_LIST(state, payload) {
      state.expensesList = payload;
    },
    SET_RETURNS_LIST(state, payload) {
      state.returnsList = payload;
    },
    SET_TRANFERS_LIST(state, payload) {
      state.tranfersList = payload;
    },
    SET_ORDERS_LIST(state, payload) {
      state.ordersList = payload;
    },
    SET_REVENUE(state, payload) {
      state.revenue = payload;
    },    SET_REGISTRATIONS(state, payload) {
      state.registrations = payload;
    },    SET_CATEGORY_SALES_DAILY(state, payload) {
      state.categorySalesDailyList = payload;
      state.categoryAnalytics.daily = payload;
    },
    SET_CATEGORY_SALES_MONTHLY(state, payload) {
      state.categorySalesMonthlyList = payload;
      state.categoryAnalytics.monthly = payload;
    },
    SET_CATEGORY_ANALYTICS(state, payload) {
      state.categoryAnalytics = payload;
    }
  },

  actions: {
    setChart({ commit }, payload) {
      const type = payload[0];
      const data = payload[1];
      // console.log(type, data)
      switch (type) {
        case "sales":
          commit("SET_SALES_LIST", data);
          break;
        case "purchases":
          commit("SET_PURCHASES_LIST", data);
          break;
        case "expenses":
          commit("SET_EXPENSES_LIST", data);
          break;
        case "returns":
          commit("SET_RETURNS_LIST", data);
          break;
        case "tranfers":
          commit("SET_TRANFERS_LIST", data);
          break;
        case "orders":
          commit("SET_ORDERS_LIST", data);
          break;
        case "revenue":
          commit("SET_REVENUE", data);
          break;
      }
    },
    clearCharts({ commit }) {
      // commit('SET_TODAY_PURCHASES_LIST',{});
      // commit('SET_WEEK_PURCHASES_LIST',{});
      // commit('SET_MONTH_PURCHASES_LIST',{});
      // commit('SET_YEAR_PURCHASES_LIST',{});
      // commit('SET_TODAY_SALES_LIST',{});
      // commit('SET_WEEK_SALES_LIST',{});
      // commit('SET_MONTH_SALES_LIST',{});
      // commit('SET_YEAR_SALES_LIST',{});
    },
    loadTodayCharts({ dispatch, commit, state, rootState }) {
      let dateFrom;
      let dateTo;
      let loadCommit;
      const currentShop = state.currentShop;
      const type = "sales";
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      const path = `users/${userId}/transactions/${type}`;
      const timeRange = "today";
      switch (timeRange) {
        case "today":
          dateFrom = Vue.moment().subtract(23, "hours");
          dateTo = Vue.moment().add(1, "hours");
          loadCommit = "SET_ALL_DAY_SALES";

          break;
      }
      return new Promise((resolve, reject) => {
        const fireDB = firebase
          .database()
          .ref()
          .child(path);
        let fireRef;
        fireRef = fireDB
          .orderByChild("time")
          .startAt(dateFrom)
          .endAt(dateTo);
        fireRef.on(
          "value",
          function(data) {
            const items = [];
            const itemList = data.val() || {};
            Object.keys(itemList).forEach(function(key) {
              if (currentShop.hasOwnProperty("id")) {
                if (type === "purchases") {
                  if (currentShop.id === itemList[key].location_to.id) {
                    items.push({
                      ...itemList[key]
                    });
                  }
                } else {
                  if (currentShop.id === itemList[key].location_from.id) {
                    items.push({
                      ...itemList[key]
                    });
                  }
                }
              } else {
                items.push({
                  ...itemList[key]
                });
              }
            });

            // // console.log('TODAY LIST : ', items);

            commit(loadCommit, items);

            commit("SET_LOADING", false);
            resolve();
          },
          function(error) {
            commit("SET_LOADING", false);
            console.error(error);
            reject();
          }
        );
      });
    },
    // loadCharts({dispatch, commit, rootState},location) {
    //     try{
    //     dispatch('clearCharts');
    //     // dispatch('loadChartByRange', {preset:'today', type:'sales'});
    //     // dispatch('loadChartByRange', {preset:'week', type:'sales'});
    //     // dispatch('loadChartByRange', {preset:'month', type:'sales'});
    //     // dispatch('loadChartByRange', {preset:'today', type:'purchases'});
    //     // dispatch('loadChartByRange', {preset:'week', type:'purchases'});
    //     // dispatch('loadChartByRange', {preset:'month', type:'purchases'});
    //     }
    //     catch(err){
    //         // console.log(err);
    //         if(!rootState.users.user){
    //                 // console.log('el usuario no esta establecido');
    //                  auth.signOut();
    //                  Cookie.remove('access_token');

    //                 dispatch('users/clearUser').then(function(){
    //                     // user info deleted
    //                     // console.log('sesion borrada')

    //                 })
    //             }else{
    //             // console.log('user : ', rootState.users.user)
    //         }

    //     }

    // },
    loadChartByRange({ state, commit, rootState }, payload) {
      commit("SET_LOADING", true);

      let dateFrom;
      let dateTo;
      let loadCommit;
      const currentShop = state.currentShop;
      const type = payload.type;
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      const path = `users/${userId}/transactions/${type}`;
      const timeRange = payload.preset;
      switch (timeRange) {
        case "today":
          dateFrom = Vue.moment()
            .subtract(23, "hours")
            .format();
          dateTo = Vue.moment()
            .add(1, "hours")
            .format();
          loadCommit =
            type === "sales"
              ? "SET_TODAY_SALES_LIST"
              : type === "purchases"
              ? "SET_TODAY_PURCHASES_LIST"
              : "";
          // // console.log('today',dateFrom, dateTo);
          break;
        case "week":
          // dateFrom = Vue.moment().startOf('isoWeek').format('YYYY-MM-DD');
          dateFrom = Vue.moment()
            .subtract(6, "days")
            .format("YYYY-MM-DD");
          dateTo = Vue.moment()
            .add(1, "days")
            .format("YYYY-MM-DD");
          // loadCommit = 'SET_WEEK_SALES_LIST';
          loadCommit =
            type === "sales"
              ? "SET_WEEK_SALES_LIST"
              : type === "purchases"
              ? "SET_WEEK_PURCHASES_LIST"
              : "";
          // // console.log('week',dateFrom, dateTo);
          break;
        case "month":
          dateFrom = Vue.moment()
            .subtract(29, "days")
            .format("YYYY-MM-DD");
          dateTo = Vue.moment()
            .add(1, "days")
            .format("YYYY-MM-DD");

          // loadCommit = 'SET_YEAR_SALES_LIST';
          loadCommit =
            type === "sales"
              ? "SET_MONTH_SALES_LIST"
              : type === "purchases"
              ? "SET_MONTH_PURCHASES_LIST"
              : "";
          // // console.log('month',dateFrom, dateTo);
          break;
        case "year":
          if (type === "sales") {
            dateFrom = Vue.moment()
              .subtract(1, "years")
              .format("YYYY-MM-DD");
            dateTo = Vue.moment()
              .add(1, "month")
              .format("YYYY-MM-DD");
          } else {
            dateFrom = Vue.moment()
              .subtract(1, "month")
              .format("YYYY-MM-DD");
            dateTo = Vue.moment()
              .add(1, "day")
              .format("YYYY-MM-DD");
          }

          // loadCommit = 'SET_YEAR_SALES_LIST';
          loadCommit =
            type === "sales"
              ? "SET_YEAR_SALES_LIST"
              : type === "purchases"
              ? "SET_YEAR_PURCHASES_LIST"
              : "";
          // // console.log('year',dateFrom, dateTo);
          break;
      }
      return new Promise((resolve, reject) => {
        const fireDB = firebase
          .database()
          .ref()
          .child(path);
        let fireRef;
        fireRef = fireDB
          .orderByChild("time")
          .startAt(dateFrom)
          .endAt(dateTo);
        fireRef.on(
          "value",
          function(data) {
            const items = [];
            const itemList = data.val() || {};
            Object.keys(itemList).forEach(function(key) {
              if (currentShop.hasOwnProperty("id")) {
                if (type === "purchases") {
                  if (currentShop.id === itemList[key].location_to.id) {
                    items.push({
                      ...itemList[key]
                    });
                  }
                } else {
                  if (currentShop.id === itemList[key].location_from.id) {
                    items.push({
                      ...itemList[key]
                    });
                  }
                }
              } else {
                items.push({
                  ...itemList[key]
                });
              }
            });

            // console.log(items)
            const grouped = _.groupBy(items, function(el) {
              if (timeRange === "today") {
                return Vue.moment(el.time).format("ha");
              }
              if (timeRange === "week") {
                return Vue.moment(el.time).format("dd");
              }
              if (timeRange === "month") {
                return Vue.moment(el.time).format("MMM D");
              }
              if (timeRange === "year") {
                return Vue.moment(el.time).format("MMM");
              }
            });

            const results = _.mapObject(grouped, function(items) {
              return items.length;
            });
            // console.log(results)
            // // console.log(results);
            let total = 0;
            let revenue = 0;
            const productList = {};
            items.forEach(element => {
              // if( Vue.moment().isSame(element.time, state.currentDateFilter))
              total += +element.total;
              if (element.items && type === "sales") {
                element.items.forEach(item => {
                  revenue += (+item.price - +item.purchase) * +item.amount;
                  if (productList[item.id]) {
                    productList[item.id].amount =
                      productList[item.id].amount + item.amount;
                  } else {
                    productList[item.id] = {
                      id: item.id,
                      name: item.name,
                      amount: item.amount
                    };
                  }
                });
              }
            });

            const productArray = Object.values(productList);
            productArray.sort((a, b) => +b.amount - +a.amount);
            // // console.log(productArray, productList);
            const format = {
              data: {
                lastElement: items.slice(-1) || null,
                revenue: revenue || null,
                total: total || null,
                list: items,
                results: results || [],
                labels: Object.keys(results),
                series: Object.values(results),
                hotSales: productArray.slice(0, 10)
              }
            };
            commit(loadCommit, format);
            // // console.log(grouped, format);
            commit("SET_LOADING", false);
            resolve();
          },
          function(error) {
            commit("SET_LOADING", false);
            console.error(error);
            reject();
          }
        );
      });
    },
    setFilterCriteria({ commit }, payload) {
      commit("SET_FILTER_CRITERIA", payload);
    },
    setCurrentShop({ commit, dispatch }, payload) {
      // console.log(payload)
      commit("SET_CURRENT_SHOP", payload);
      // dispatch('loadCharts');
    },
    clearCurrentShop({ commit, dispatch }) {
      commit("SET_CURRENT_SHOP", null);
    },
    loadLog({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        // // console.log(payload);
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }
        let path;
        let loadCommit;
        const type = payload[0];
        commit("SET_CURRENT_TYPE", type);
        const from = payload[1];
        const to = payload[2];
        if (type === "all") {
          path = `users/${userId}/transactions`;
        } else {
          path = `users/${userId}/transactions/${type}`;
        }

        const fireDB = firebase
          .database()
          .ref()
          .child(path);
        switch (type) {
          case "purchases":
            loadCommit = "SET_PURCHASES_LIST";
            break;
          case "sales":
            loadCommit = "SET_SALES_LIST";
            break;
          case "transfers":
            loadCommit = "SET_TRANSFERS_LIST";
            break;
          case "all":
            loadCommit = "SET_TRANSACTION_lIST";
            break;
        }

        let fireRef;
        // // console.log(from, to);
        if (type === "all") {
          fireRef = fireDB;
        } else {
          if (from && to) {
            fireRef = fireDB
              .orderByChild("time")
              .startAt(from)
              .endAt(to);
          } else if (!from || !to) {
            fireRef = from
              ? fireDB.orderByChild("time").startAt(from)
              : to
              ? fireDB.orderByChild("time").endAt(to)
              : fireDB;
          }
        }
        fireRef.on(
          "value",
          function(data) {
            const items = [];
            const itemList = data.val() || {};
            Object.keys(itemList).forEach(function(key) {
              items.push({
                ...itemList[key]
              });
            });
            commit("SET_LOADING", false);

            commit(loadCommit, items);
            // // console.log(items);
            resolve();
          },
          function(error) {
            commit("SET_LOADING", false);
            console.error(error);
            reject();
          }
        );
      });
    },
    async sendBill({ commit, state, rootState }, payload) {
      let userId = "";
      if (rootState.users.user.adminUid) {
        userId = rootState.users.user.adminUid;
      } else {
        userId = rootState.users.user.uid;
      }
      commit("SET_LOADING", true);
      const transactionKey = firebase
        .database()
        .ref()
        .child(`users/${userId}/transactions/${payload.type}`)
        .push().key;
      payload.id = transactionKey;
      await firebase
        .database()
        .ref()
        .child(`users/${userId}/transactions/${payload.type}/${transactionKey}`)
        .update(payload)
        .then(function() {
          setTimeout(function() {
            commit("SET_LOADING", false);
          }, 500);
        });
    },
    top20Products({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(vars.url + "/top20Products", data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    summaryByProduct({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(vars.url + "/summaryByProduct", data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    summaryByCollaborator({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(vars.url + "/summaryByCollaborator", data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    inventoryCost({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(vars.url + "/inventoryCost", data)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },    async getAllRegistrations({ commit }, datesInfo) {
      // console.log(datesInfo)
      return new Promise((resolve, reject) => {
        let loadCommit = "SET_REGISTRATIONS";
        axios
          .post(vars.url + "/getAllSubscriptions", datesInfo)
          .then(res => {
            const data = functions.decryptData(res.data);
           // console.log(data, 'subscriptions data')
            commit(loadCommit, data);
            resolve(data);
          })
          .catch(e => {
            // console.log(e)
            reject();
          });
      });
    },

    // Category Analytics Actions
    loadCategoryAnalytics({ commit, rootState }, { timeRange = 'daily', dateFrom, dateTo }) {
      return new Promise(async (resolve, reject) => {
        commit("SET_LOADING", true);
        
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }

        try {
          // Step 1: Calculate date ranges for current and previous periods
          let currentDateFrom, currentDateTo, previousDateFrom, previousDateTo;
          
          if (dateFrom && dateTo) {
            currentDateFrom = dateFrom;
            currentDateTo = dateTo;
            
            // Calculate previous period of the same length
            const daysDiff = Vue.moment(dateTo).diff(Vue.moment(dateFrom), 'days');
            previousDateTo = Vue.moment(dateFrom).subtract(1, 'day').format('YYYY-MM-DD');
            previousDateFrom = Vue.moment(previousDateTo).subtract(daysDiff, 'days').format('YYYY-MM-DD');
          } else {
            // Default: last 7 days vs previous 7 days
            currentDateFrom = Vue.moment().subtract(6, 'days').format('YYYY-MM-DD');
            currentDateTo = Vue.moment().format('YYYY-MM-DD');
            previousDateFrom = Vue.moment().subtract(13, 'days').format('YYYY-MM-DD');
            previousDateTo = Vue.moment().subtract(7, 'days').format('YYYY-MM-DD');
          }

          // Step 2: Get sales data for current period
          const salesRef = firebase.database().ref(`users/${userId}/transactions/sales`);
          const currentSalesQuery = salesRef.orderByChild('time').startAt(currentDateFrom).endAt(currentDateTo + 'T23:59:59');
          const currentSalesSnapshot = await currentSalesQuery.once('value');
          const currentSalesData = currentSalesSnapshot.val() || {};

          // Step 3: Get sales data for previous period
          const previousSalesQuery = salesRef.orderByChild('time').startAt(previousDateFrom).endAt(previousDateTo + 'T23:59:59');
          const previousSalesSnapshot = await previousSalesQuery.once('value');
          const previousSalesData = previousSalesSnapshot.val() || {};

          // Step 4: Get products to map categories
          const productsRef = firebase.database().ref(`users/${userId}/inventory`);
          const productsSnapshot = await productsRef.once('value');
          const productsData = productsSnapshot.val() || {};

          // Step 5: Process current period sales data
          const currentCategoryAnalytics = {};
          const currentCategoryTotals = {};

          const processSalesData = (salesData, categoryAnalytics, categoryTotals) => {
            Object.values(salesData).forEach(sale => {
              if (!sale.items || !sale.time) return;

              const saleDate = Vue.moment(sale.time).format('YYYY-MM-DD');
              
              if (!categoryAnalytics[saleDate]) {
                categoryAnalytics[saleDate] = {};
              }

              sale.items.forEach(item => {
                const product = productsData[item.id];
                if (!product || !product.categories || !product.categories.length) {
                  // If no category, assign to "Sin categoría"
                  const categoryId = 'no-category';
                  const categoryName = 'Sin categoría';
                  
                  if (!categoryAnalytics[saleDate][categoryId]) {
                    categoryAnalytics[saleDate][categoryId] = {
                      categoryId,
                      categoryName,
                      totalSales: 0,
                      totalRevenue: 0,
                      totalOrders: 0,
                      totalQuantity: 0
                    };
                  }

                  if (!categoryTotals[categoryId]) {
                    categoryTotals[categoryId] = {
                      categoryId,
                      categoryName,
                      totalSales: 0,
                      totalRevenue: 0,
                      totalOrders: 0,
                      totalQuantity: 0
                    };
                  }

                  const itemTotal = parseFloat(item.total || item.price * item.amount || 0);
                  const itemCost = parseFloat(item.purchase || (product && product.price && product.price.buy) || 0) * parseFloat(item.amount || 1);
                  const itemRevenue = itemTotal - itemCost;

                  categoryAnalytics[saleDate][categoryId].totalSales += itemTotal;
                  categoryAnalytics[saleDate][categoryId].totalRevenue += itemRevenue;
                  categoryAnalytics[saleDate][categoryId].totalOrders += 1;
                  categoryAnalytics[saleDate][categoryId].totalQuantity += parseFloat(item.amount || 1);
                  
                  categoryTotals[categoryId].totalSales += itemTotal;
                  categoryTotals[categoryId].totalRevenue += itemRevenue;
                  categoryTotals[categoryId].totalOrders += 1;
                  categoryTotals[categoryId].totalQuantity += parseFloat(item.amount || 1);
                  return;
                }

                // Process each category of the product
                product.categories.forEach(category => {
                  const categoryId = category.id;
                  const categoryName = category.name;

                  if (!categoryAnalytics[saleDate][categoryId]) {
                    categoryAnalytics[saleDate][categoryId] = {
                      categoryId,
                      categoryName,
                      totalSales: 0,
                      totalRevenue: 0,
                      totalOrders: 0,
                      totalQuantity: 0
                    };
                  }

                  if (!categoryTotals[categoryId]) {
                    categoryTotals[categoryId] = {
                      categoryId,
                      categoryName,
                      totalSales: 0,
                      totalRevenue: 0,
                      totalOrders: 0,
                      totalQuantity: 0
                    };
                  }

                  const itemTotal = parseFloat(item.total || item.price * item.amount || 0);
                  const itemCost = parseFloat(item.purchase || (product && product.price && product.price.buy) || 0) * parseFloat(item.amount || 1);
                  const itemRevenue = itemTotal - itemCost;

                  categoryAnalytics[saleDate][categoryId].totalSales += itemTotal;
                  categoryAnalytics[saleDate][categoryId].totalRevenue += itemRevenue;
                  categoryAnalytics[saleDate][categoryId].totalOrders += 1;
                  categoryAnalytics[saleDate][categoryId].totalQuantity += parseFloat(item.amount || 1);
                  
                  categoryTotals[categoryId].totalSales += itemTotal;
                  categoryTotals[categoryId].totalRevenue += itemRevenue;
                  categoryTotals[categoryId].totalOrders += 1;
                  categoryTotals[categoryId].totalQuantity += parseFloat(item.amount || 1);
                });
              });
            });
          };

          // Process current period
          processSalesData(currentSalesData, currentCategoryAnalytics, currentCategoryTotals);

          // Process previous period
          const previousCategoryTotals = {};
          processSalesData(previousSalesData, {}, previousCategoryTotals);

          // Step 6: Calculate growth rates
          Object.keys(currentCategoryTotals).forEach(categoryId => {
            const current = currentCategoryTotals[categoryId];
            const previous = previousCategoryTotals[categoryId];
            
            if (previous && previous.totalRevenue > 0) {
              const growth = ((current.totalRevenue - previous.totalRevenue) / previous.totalRevenue) * 100;
              current.growth = Math.round(growth * 100) / 100; // Round to 2 decimal places
            } else if (current.totalRevenue > 0) {
              current.growth = 100; // New category, 100% growth
            } else {
              current.growth = 0;
            }
          });

          // Step 7: Add growth data to daily analytics
          Object.keys(currentCategoryAnalytics).forEach(date => {
            Object.keys(currentCategoryAnalytics[date]).forEach(categoryId => {
              if (currentCategoryTotals[categoryId]) {
                currentCategoryAnalytics[date][categoryId].growth = currentCategoryTotals[categoryId].growth;
              }
            });
          });

          // Step 8: Store category totals for easy access
          const analyticsWithTotals = {
            ...currentCategoryAnalytics,
            _totals: currentCategoryTotals,
            _previousTotals: previousCategoryTotals,
            _dateRange: {
              currentFrom: currentDateFrom,
              currentTo: currentDateTo,
              previousFrom: previousDateFrom,
              previousTo: previousDateTo
            }
          };

          // Set the processed data in the store
          const commitType = timeRange === 'daily' ? 'SET_CATEGORY_SALES_DAILY' : 'SET_CATEGORY_SALES_MONTHLY';
          commit(commitType, analyticsWithTotals);
          commit("SET_LOADING", false);
          resolve(analyticsWithTotals);

        } catch (error) {
          commit("SET_LOADING", false);
          console.error("Error loading category analytics:", error);
          reject(error);
        }
      });
    },

    loadCategorySalesChart({ commit, dispatch, rootState }, { timeRange = 'daily', dateRange = 7 }) {
      return new Promise((resolve, reject) => {
        let userId = "";
        if (rootState.users.user.adminUid) {
          userId = rootState.users.user.adminUid;
        } else {
          userId = rootState.users.user.uid;
        }

        const periodPath = timeRange === 'daily' ? 'daily' : 'monthly';
        const path = `users/${userId}/analytics/categories/${periodPath}`;
        
        // Calculate date range
        let startDate, endDate;
        if (timeRange === 'daily') {
          startDate = Vue.moment().subtract(dateRange - 1, 'days').format('YYYY-MM-DD');
          endDate = Vue.moment().format('YYYY-MM-DD');
        } else {
          startDate = Vue.moment().subtract(dateRange - 1, 'months').format('YYYY-MM');
          endDate = Vue.moment().format('YYYY-MM');
        }

        dispatch('loadCategoryAnalytics', { timeRange, dateFrom: startDate, dateTo: endDate })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    }
  },

  getters: {
    getTodaySales: (state, getters) => shop => {
      const shopList = state.allDaySales.filter(function(el) {
        return el.location_from.id === shop.id;
      });
      const grouped = _.groupBy(shopList, function(el) {
        return Vue.moment(el.time).format("ha");
      });
      const results = _.mapObject(grouped, function(items) {
        return items.length;
      });

      let total = 0;
      let revenue = 0;
      const productList = {};
      shopList.forEach(element => {
        // if( Vue.moment().isSame(element.time, state.currentDateFilter))
        total += +element.total;
        if (element.items && type === "sales") {
          element.items.forEach(item => {
            revenue += (+item.price - +item.purchase) * +item.amount;
            if (productList[item.id]) {
              productList[item.id].amount =
                productList[item.id].amount + item.amount;
            } else {
              productList[item.id] = {
                id: item.id,
                name: item.name,
                amount: item.amount
              };
            }
          });
        }
      });
      const productArray = Object.values(productList);
      productArray.sort((a, b) => +b.amount - +a.amount);
      // // console.log(productArray, productList);
      return {
        data: {
          lastElement: shopList.slice(-1) || null,
          revenue: revenue || null,
          total: total || null,
          list: shopList,
          results: results || [],
          labels: Object.keys(results),
          series: Object.values(results),
          hotSales: productArray.slice(0, 10)
        }
      };
    },
    getDailyPurchasesChart: (state, getters) => {
      return state.purchasesDayList;
    },
    getWeeklyPurchasesChart: (state, getters) => {
      return state.purchasesWeekList;
    },
    getMonthlyPurchasesChart: (state, getters) => {
      return state.purchasesMonthList;
    },
    getYearlyPurchasesChart: (state, getters) => {
      return state.purchasesYearList;
    },
    getDailySalesChart: (state, getters) => {
      return state.salesDayList;
    },
    getWeeklySalesChart: (state, getters) => {
      return state.salesWeekList;
    },
    getMonthlySalesChart: (state, getters) => {
      return state.salesYearList;
    },
    getCurrentType: (state, getters) => {
      return state.currentType;
    },
    getLog(state, rootGetters) {
      let transactions;

      const type = state.currentType;
      switch (type) {
        case "sales":
          transactions = state.sales;
          break;
        case "purchases":
          transactions = state.purchases;
          break;
        case "transfers":
          transactions = state.transfers;
          break;
        case "all":
          transactions = [
            ...state.sales,
            ...state.purchases,
            ...state.transfers
          ];
          break;
      }

      if (state.criteria !== "") {
        return transactions.filter(el => {
          if (el.items) {
            for (let i = 0; i < el.items.length; i++) {
              if (el.items[i].name.includes(state.criteria)) {
                return true;
                break;
              }
            }
          }
        });
      } else {
        return transactions;
      }
    },

    getTransactionsTotal: (state, getters) => {
      let total = 0;
      if (getters.getLog) {
        const list = getters.getLog || {};
        list.forEach(element => {
          // if( Vue.moment().isSame(element.time, state.currentDateFilter))
          total += +element.total;
        });
        return total;
      }
      return 0;
    },
    getRevenueTotal: (state, getters) => {
      let total = 0;
      if (getters.getLog) {
        const list = getters.getLog || {};
        list.forEach(element => {
          if (element.items) {
            element.items.forEach(item => {
              if (item.purchase) {
                total += (+item.price - +item.purchase) * +item.amount;
              }
            });
          }
        });
        return total;
      }
      return 0;
    },

    getAllTransactions(state) {
      return state.transactions;
    },
    getTransactionType({ state }, type) {
      switch (type) {
        case "all":
          return state.transactions;
          break;
        case "sales":
          return state.sales;
          break;
        case "purchases":
          return state.purchases;
          break;
        case "transfers":
          return state.transfers;
          break;
      }
    },
    getProductLog(state) {
      const productLog = [];
      let transactions;

      switch (state.currentType) {
        case "sales":
          transactions = state.sales;
          break;
        case "purchases":
          transactions = state.purchases;
          break;
        case "transfers":
          transactions = state.transfers;
          break;
        case "all":
          transactions = [
            ...state.sales,
            ...state.purchases,
            ...state.transfers
          ];
          break;
      }

      try {
        const log = transactions.filter(el => {
          for (let i = 0; i < el.items.length; i++) {
            if (el.items[i].name.includes(state.currentItem.name)) {
              return true;
              break;
            }
          }
        });

        log.forEach(item => {
          item.items.forEach(el => {
            if (el.name.includes(state.currentItem.name)) {
              productLog.push({
                location: item.location,
                name: el.name,
                time: item.time,
                type: item.type,
                amount: +el.amount,
                purchase: +el.purchase,
                price: +el.price,
                total: (+el.price * el.amount) | 0,
                utility: ((+el.price - +el.purchase) * 100) / +el.price
              });
            }
          });
        });
        // // console.log(log);
        return productLog;
      } catch (err) {
        // // console.log(err);
        //
      }
    },

    getItems(state) {
      return state.shops_list;
    },
    getCurrentItem(state) {
      return state.currentItem;
    },
    getLoading(state) {
      return state.isLoading;
    },
    getRegistrations(state) {
      return state.registrations;
    }
  }
};
